import { JobList } from "./JobList";
import { JobShow } from "./JobShow";
import { JobCreate } from "./JobCreate";

export default {
  list: JobList,
  show: JobShow,
  create: JobCreate,
};
